/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import moment from 'moment';
import PropTypes from 'prop-types';
import { ModalRoute } from 'react-router-modal';
import BookingDetailsStrikesWidget from './BookingDetailsStrikesWidget';
import BookingStartTimeWidget from '../BookingStartTimeWidget';
import BookingEndTimeWidget from '../BookingEndTimeWidget';
import BookingStatusSelectPicker from '../BookingStatusSelectPicker';
import './bookingDetailsMain.scss';
import { WorkerAgency } from '../../../freelancer-details/FreelancerDetailsHeader';
import Tooltip from '../../../common/Tooltip';

import history from '../../../../history';

const propTypes = {
    job: PropTypes.object.isRequired,
    relevantJobId: PropTypes.object.isRequired,
    notification: PropTypes.object.isRequired,
    table: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};

class BookingDetailsMain extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { job, user } = this.props;
        const workerImage = job.booking.freelancer_detail.photo_thumbnail_large
            ? job.booking.freelancer_detail.photo_thumbnail_large
            : '/static/images/default_profile.png';
        const agencyLogo =
            job.managing_agency_details && job.managing_agency_details.logo;
        const agencyName =
            job.managing_agency_details &&
            job.managing_agency_details.company_name;

        const isManager =
            this.props.clientData.userData.content.permissions.includes(
                'auth.manage_postjob_ops',
            );
        const isDelegatedJob =
            user.isAgent && user.agency.id !== job.managing_agency_details.id;
        const isManagedJob =
            user.isAgent && user.agency.id === job.managing_agency_details.id;

        return (
            <div className="booking-details-main">
                <div className="booking-details-main__column">
                    <div className="booking-details-main__avatar">
                        <img src={workerImage} />
                        {isDelegatedJob && (
                            <WorkerAgency
                                logo={agencyLogo}
                                agencyName={agencyName}
                            />
                        )}
                        <NavLink
                            to={`/operations/freelancer/${
                                job.booking
                                    ? job.booking.freelancer_detail.id
                                    : ''
                            }`}
                            className="booking-details-main__name"
                        >
                            {job.booking.freelancer_detail.full_name}
                        </NavLink>
                    </div>
                </div>
                <div className="booking-details-main__column">
                    <span className="booking-details-main__date-time">
                        {moment(job.start_datetime).format('dddd Do MMMM YYYY')}
                    </span>
                    <div className="booking-details-main__row">
                        <div className="booking-details-main__times">
                            <div className="booking-details-main__time">
                                <div className="start-time__row">
                                    <BookingStartTimeWidget
                                        job={job}
                                        notification={this.props.notification}
                                        table={this.props.table}
                                        enableModal={false}
                                        enableLinkToModal={
                                            isManager && isManagedJob
                                        }
                                    />
                                </div>
                            </div>
                            <div className="booking-details-main__time">
                                <div className="end-time__row">
                                    <BookingEndTimeWidget
                                        job={job}
                                        notification={this.props.notification}
                                        table={this.props.table}
                                        enableModal={false}
                                        enableLinkToModal={
                                            isManager && isManagedJob
                                        }
                                    />
                                </div>
                            </div>
                            <span className="booking-details-main__duration">
                                {job.booking.datetime_finished &&
                                job.booking.datetime_finished
                                    ? parseFloat(
                                          moment(job.booking.datetime_finished)
                                              .diff(
                                                  job.booking.datetime_started,
                                                  'hours',
                                                  true,
                                              )
                                              .toFixed(2),
                                      )
                                    : job.duration}
                                h
                            </span>
                        </div>
                        <div className="booking-details-main__status">
                            <Tooltip tooltip="Booking status">
                                <div className="booking-details-main__status-content">
                                    <BookingStatusSelectPicker
                                        key={job.booking.id}
                                        job={job}
                                        relevantJobId={this.props.relevantJobId}
                                        notification={this.props.notification}
                                        disabled={!isManager || !isManagedJob}
                                    />
                                    {isManager && isManagedJob && (
                                        <i className="icon icon-pencil-2" />
                                    )}
                                </div>
                            </Tooltip>
                            {isManager && isManagedJob && (
                                <div className="booking-details-main__strikes-content">
                                    <NavLink
                                        to={`${this.props.location.pathname}strikes/${this.props.location.search}`}
                                        className="booking-details-main"
                                    >
                                        {job.booking.strikes_count != undefined
                                            ? `${
                                                  job.booking.strikes_count
                                              } strike${
                                                  job.booking.strikes_count != 1
                                                      ? 's'
                                                      : ''
                                              }`
                                            : 'Strikes'}
                                    </NavLink>
                                    <ModalRoute
                                        id={job.booking.id}
                                        path={`${this.props.match.path}/strikes/`}
                                        component={BookingDetailsStrikesWidget}
                                        linkClassName="clock-link"
                                        props={{
                                            job,
                                            relevantJobId: this.props.relevantJobId,
                                            notification: this.props.notification,
                                            table: this.props.table,
                                        }}
                                        onBackdropClick={() => {
                                            const pathname =
                                                this.props.location.pathname.replace(
                                                    '/strikes',
                                                    '',
                                                );
                                            history.push(
                                                pathname +
                                                    this.props.location.search,
                                            );
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

BookingDetailsMain.propTypes = propTypes;

function mapStateToProps(state) {
    return {
        clientData: state.clientData,
        user: state.user,
    };
}

export default connect(mapStateToProps)(BookingDetailsMain);
